import { createContext } from 'react'

const FollowUpContext = createContext()

export default FollowUpContext
